import { render, staticRenderFns } from "./clientLogs.vue?vue&type=template&id=218b64a2&scoped=true"
import script from "./clientLogs.vue?vue&type=script&lang=js"
export * from "./clientLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b64a2",
  null
  
)

export default component.exports